import common from './common';
import configurator from './configurator';

export default {
  get isReady() {
    return window.vp.sf.complexConfigurator !== undefined;
  },

  get callToAction() {
    return window.vp.sf.complexConfigurator.AppStart.model.callToAction;
  },

  get callToActionUrlProvider() {
    return window.vp.sf.complexConfigurator.AppStart.model.callToActionUrlProvider;
  },

  get projectAdapter() {
    return window.vp.sf.complexConfigurator.AppStart.model.project;
  },

  onReady(callback) {
    if (this.isReady()) {
      callback();
    } else {
      common.dispatcher.on(configurator.constants.EVENTS.VIEWS_INITIALIZED, callback);
    }
  },
};
